import { Flex, Icon, Spacer, spaces, Text, Tooltip } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ListStyled = styled.ul`
  padding-left: ${spaces.space_m_rem};
  margin-top: ${spaces.space_2xs_rem};
  margin-bottom: 0;
`;

const AutopayTooltip = () => {
  const { t } = useTranslation('billing');
  const tooltipContent = (
    <Flex vertical>
      <Text variant="label-small">{t('autopay.tooltip.includedTitle')}</Text>
      <ListStyled>
        <li>
          <Text variant="body-2">
            {t('autopay.tooltip.includedItems.ithPlan')}
          </Text>
        </li>
        <li>
          <Text variant="body-2">
            {t('autopay.tooltip.includedItems.warehousingFees')}
          </Text>
        </li>
        <li>
          <Text variant="body-2">
            {t('autopay.tooltip.includedItems.shippingCosts')}
          </Text>
        </li>
        <li>
          <Text variant="body-2">
            {t('autopay.tooltip.includedItems.qrCodes')}
          </Text>
        </li>
      </ListStyled>
      <Spacer y={spaces.space_xs_rem} />
      <Text variant="label-small">{t('autopay.tooltip.notIncludedTitle')}</Text>
      <ListStyled>
        <li>
          <Text variant="body-2">
            {t('autopay.tooltip.notIncludedItems.hardwarePurchases')}
          </Text>
        </li>
      </ListStyled>
    </Flex>
  );

  return (
    <Tooltip content={tooltipContent} placement="right-end">
      <Icon icon="information-circle" size="small" />
    </Tooltip>
  );
};

export default AutopayTooltip;
